'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dGroups$002dPage$0024 from "./presto.-List-Groups-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002475 from "./presto.-Presto-Router$$anon$75.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$74() {
  this.bmX = null;
  this.bmP = null;
  this.bmQ = false;
  this.bmY = null;
  this.bmZ = false;
  this.bn2 = null;
  this.bmV = null;
  this.bmW = false;
  this.bmR = null;
  this.bmS = false;
  this.bmT = null;
  this.bmU = false;
  this.bn0 = false;
  this.bn1 = false;
  this.bmX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bn2 = "ListGroupsPage";
}
export { $c_Lpresto_PrestoRouter$$anon$74 as $c_Lpresto_PrestoRouter$$anon$74 };
$p = $c_Lpresto_PrestoRouter$$anon$74.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$74;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$74() {
}
export { $h_Lpresto_PrestoRouter$$anon$74 as $h_Lpresto_PrestoRouter$$anon$74 };
$h_Lpresto_PrestoRouter$$anon$74.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bmX;
});
$p.L = (function() {
  if ((!this.bmQ)) {
    this.bmP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bmQ = true;
  }
  return this.bmP;
});
$p.O = (function() {
  if ((!this.bmZ)) {
    this.bmY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bmZ = true;
  }
  return this.bmY;
});
$p.E = (function() {
  return this.bn2;
});
$p.t = (function() {
  if ((!this.bmW)) {
    this.bmV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bmW = true;
  }
  return this.bmV;
});
$p.M = (function() {
  if ((!this.bmS)) {
    this.bmR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bmS = true;
  }
  return this.bmR;
});
$p.Q = (function() {
  if ((!this.bmU)) {
    this.bmT = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002475.$c_Lpresto_PrestoRouter$$anon$75();
    this.bmU = true;
  }
  return this.bmT;
});
$p.w = (function() {
  if ((!this.bn1)) {
    this.bn0 = false;
    this.bn1 = true;
  }
  return this.bn0;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee514) => ((p) => \u03b4scrutinee514))($j_presto$002e$002dList$002dGroups$002dPage$0024.$m_Lpresto_ListGroupsPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$74 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$74, "presto.PrestoRouter$$anon$74", ({
  OI: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$74 as $d_Lpresto_PrestoRouter$$anon$74 };
//# sourceMappingURL=presto.-Presto-Router$$anon$74.js.map
